<app-range-bar
  [range]="data.model"
  [minGebruik]="data.minGebruikPerWeek"
  [maxGebruik]="data.maxGebruikPerWeek"
  *ngIf="!data.hidden">
</app-range-bar>
